export default function LoginForm() {
    return {
        restrict: "E",
        scope: {
            submitText: "=",
            modal: "=",
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            $rootScope,
            $location,
            authService,
            userService
        ) {
            $scope.displayForgotPasswordLink = false;

            // DEP:: has moved to AUTH server

            // Borger
            userService.user.customerTypeId = 3;

            $scope.user = userService.user;

            $scope.message = "";

            $scope.goToResetPassword = function (URLendpoint) {
                if ($scope.modal == true) {
                    var args = {
                        action: "redirect",
                        location: URLendpoint,
                    };

                    $rootScope.$broadcast(
                        "close-modal-change-location-broadcast",
                        args
                    );
                } else {
                    $location.path(URLendpoint);
                }
            };

            $scope.login = function () {
                authService.login($scope.user).then(
                    function () {
                        //avail param: response
                        // clear password from user Object
                        userService.user.password = "";

                        if ($scope.modal == true) {
                            // gets passed as directive property

                            //When the user needs to login before entering the booking flow
                            $rootScope.$broadcast(
                                "close-modal-and-booknow-broadcast"
                            );
                        } else {
                            var redirUrl = "/"; // default

                            // console.log(' return url : ' +  authService.loginReturnUrl);

                            if (authService.loginReturnUrl) {
                                // store
                                redirUrl = authService.loginReturnUrl;

                                //then reset
                                authService.loginReturnUrl = null;
                            }

                            $location.path(redirUrl);
                        }
                    },
                    function (err) {
                        $scope.message = err.error_description;
                    }
                );
            };
        },
    };
}
